import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { playgroundUrls, productionUrls } from '../config';
import { CheggEnv } from '@chegg/utils';
var MAX_RETRIES = 3;
function createApolloClient(environment) {
  var _ref = environment == CheggEnv.PROD ? productionUrls() : playgroundUrls(),
    bffUrl = _ref.bffUrl;
  var httpLink = createHttpLink({
    uri: bffUrl
  });
  var retryLink = new RetryLink({
    delay: {
      initial: 100,
      max: 200,
      jitter: false
    },
    attempts: {
      max: MAX_RETRIES
    }
  });
  return new ApolloClient({
    link: retryLink.concat(httpLink),
    cache: new InMemoryCache()
  });
}
export var bffApolloClient = function bffApolloClient(environment) {
  return createApolloClient(environment);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/apollo/bffClient.js
// module id = 2878
// module chunks = 11